"use client"

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"

const Header = () => {
  const navigate = useNavigate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
  })
  // Add loading state if you want to use it
  // const [loading, setLoading] = useState(false);
  
  const API_BASE_URL = 'https://api.tenarx.net';
  const fetchProfileData = async () => {
    try {
      const token = localStorage.getItem("userToken") || localStorage.getItem("token")
      const response = await fetch(`${API_BASE_URL}/api/personal-info/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })

      if (response.ok) {
        const data = await response.json()
        if (data.success) {
          setFormData({
            firstName: data.data.personalInfo.firstName || "",
            lastName: data.data.personalInfo.lastName || "",
            email: data.data.user.email || "",
          })
        }
      }
    } catch (error) {
      console.error("Error fetching profile:", error)
    } finally {
      // Remove or uncomment the next line if you want to use loading state
      // setLoading(false)
    }
  }

const getInitials = (firstName, lastName) => {
  const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
  const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
  return `${firstInitial}${lastInitial}`;
};

  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token") || localStorage.getItem("userToken")
      if (token) {
        await fetch(`${API_BASE_URL}/api/auth/logout`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
      }
    } catch (error) {
      console.error("Logout error:", error)
    } finally {
      localStorage.removeItem("token")
      localStorage.removeItem("userToken")
      localStorage.removeItem("user")
      navigate("/login")
    }
  }
   useEffect(() => {
      fetchProfileData()
      
    }, [])

  return (
    <nav className="fixed top-0 z-50 w-full bg-white border-b border-gray-200 shadow-sm">
      <div className="px-3 py-3 lg:px-5 lg:pl-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-start">
            <button
              data-drawer-target="logo-sidebar"
              data-drawer-toggle="logo-sidebar"
              aria-controls="logo-sidebar"
              type="button"
              className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
            >
              <span className="sr-only">Open sidebar</span>
              <svg
                className="w-6 h-6"
                aria-hidden="true"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clipRule="evenodd"
                  fillRule="evenodd"
                  d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                />
              </svg>
            </button>
            <a href="/dashboard" className="flex ms-2 md:me-24">
              <div className="h-8 w-8 bg-blue-600 rounded-lg flex items-center justify-center me-3">
                <span className="text-white font-bold text-lg">T</span>
              </div>
              <span className="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap text-gray-900">
                TenaRX
              </span>
            </a>
          </div>
          <div className="flex items-center">
            <div className="flex items-center ms-3">
              <div className="relative">
                <button
                  type="button"
                  className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300"
                  aria-expanded="false"
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <span className="sr-only">Open user menu</span>
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <span className="text-white font-medium text-sm">{
                    getInitials(formData.firstName, formData.lastName)}</span>
                  </div>
                </button>
                {isDropdownOpen && (
                  <div className="absolute right-0 z-50 mt-2 w-48 bg-white divide-y divide-gray-100 rounded-lg shadow-lg">
                    <div className="px-4 py-3">
                      <p className="text-sm text-gray-900">{formData.firstName} {formData.lastName}</p>
                      <p className="text-sm font-medium text-gray-500 truncate">{formData.email}</p>
                    </div>
                    <ul className="py-1">
                      
                      <li>
                        <button
                          onClick={handleLogout}
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          Sign out
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Header
